/* @ngInject */

export default (
  HomeLoanApplicationBackChannelHistory,
  HomeLoanApplicationLodgeHistory,
  dateTimeService
) => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function HomeLoanApplication(
    id,
    applicationId,
    lenderAssignedId,
    idLender,
    idOrganization,
    idTicket,
    isActive,
    isSubmitted,
    status,
    type,
    contacts,
    ticket,
    loan,
    lodgeHistory,
    backChannelMessagesHistory,
    timeStamp
  ) {
    this.id = id;
    this.applicationId = applicationId;
    this.lenderAssignedId = lenderAssignedId;
    this.idLender = idLender;
    this.idOrganization = idOrganization;
    this.idTicket = idTicket;
    this.status = status;
    this.type = type;
    this.contacts = contacts;
    this.ticket = ticket;
    this.loan = loan;
    this.lodgeHistory = lodgeHistory;
    this.backChannelMessagesHistory = backChannelMessagesHistory;
    this.timeStamp = timeStamp;
    this.isSubmitted = isSubmitted;
    this.isActive = isActive;
  }

  /*
   * Static methods
   * --------------------------------------------------------------------------------
   */
  HomeLoanApplication.Blank = function () {
    return HomeLoanApplication.Build({
      id: '',
      applicationId: '',
      lenderAssignedId: '',
      idLender: '',
      idOrganization: '',
      idTicket: '',
      status: '',
      type: '',
      contacts: [],
      ticket: {},
      loan: {},
      lodgeHistory: [HomeLoanApplicationLodgeHistory.Blank()],
      backChannelMessagesHistory: [HomeLoanApplicationBackChannelHistory.Blank()],
      timeStamp: dateTimeService.epoch(),
      isSubmitted: false,
      isActive: false
    });
  };
  HomeLoanApplication.Build = function (data) {
    return new HomeLoanApplication(
      data.id ? data.id : '',
      data.applicationId ? data.applicationId : '',
      data.lenderAssignedId ? data.lenderAssignedId : '',
      data.idLender ? data.idLender : '',
      data.idOrganization ? data.idOrganization : '',
      data.idTicket ? data.idTicket : '',
      data.status ? data.status : '',
      data.type ? data.type : '',
      data.contacts ? data.contacts : '',
      data.ticket ? data.ticket : '',
      data.loan ? data.loan : '',
      _.map(_.compact(data.lodgeHistory), (lodgeHistory) =>
        HomeLoanApplicationLodgeHistory.Build(lodgeHistory)
      ),
      _.map(_.compact(data.backChannelMessagesHistory), (backChannelMessagesHistory) =>
        HomeLoanApplicationBackChannelHistory.Build(backChannelMessagesHistory)
      ),
      data.timeStamp ? data.timeStamp : dateTimeService.epoch(),
      data.isSubmitted ? data.isSubmitted : false,
      data.isActive ? data.isActive : false
    );
  };

  return HomeLoanApplication;
};
